import React, { useState, useEffect } from "react"
import {
  TabContent,
  TabPane,
  NavLink,
  NavItem,
  Nav,
  Row,
  Col,
  Container,
} from "reactstrap"
import classnames from "classnames"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"

import FactoryDepartments from "./Departments" 
import FactoryTeams from "./Team"
import FactoryForms from "./Forms"
import ReportScoring from "./ReportScoring"
import ValidationConfig from "./ValidationConfig"
import AssignTasks from "./AssignTasks"
import * as backend from "../../helpers/backend_helper"
import Breadcrumb from "../../components/Common/Breadcrumb2"
import BackButton from "../../common/ui/backButton"
import LeftNavReport from "./Reports/Reports"

// Redux Store
import { fetchFactories } from "store/slice/factory.slice"

const FactoryDetails = (props: any) => {
  const {
    match: {
      params: { orgId, facId },
      url: locationUrl,
    },
  } = props
  const [customActiveTab, setcustomActiveTab] = useState("1")
  const [factory, setFactory] = useState<any>()
  const [count, setCount] = useState(true)

  function toggleCustom(tab: any) {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  async function getFactory() {
    try {
      const response = await backend.getFactoryByID(orgId, facId)
      props.saveUserFactory()
      setFactory(response[0])
    } catch (e) { }
  }

  useEffect(() => {
    if (count) {
      getFactory()
      setCount(false)
    }
  }, [count])
  // console.log("factoryfactoryfactoryfactory", factory)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="mw-detail-header">
            <button
              type="button"
              className="mw-back-btn"
              title="Back"
              onClick={() => props.history.goBack()}
            >
              <i className="mdi mdi-arrow-left" />
            </button>
            <div className="mw-detail-titles">
              <div className="mw-crumb">
                <Link to="/orgs/list">Organization</Link>
                <span className="mw-crumb-sep">/</span>
                <Link
                  to={
                    locationUrl && locationUrl.split("factory")[0]
                      ? locationUrl.split("factory")[0] + "factory/list"
                      : "#"
                  }
                >
                  Factory
                </Link>
                <span className="mw-crumb-sep">/</span>
                <span className="mw-crumb-current">
                  {(factory && factory.name) || "Settings"}
                </span>
              </div>
              <h4>{(factory && factory.name) || "Factory"}</h4>
              <p>Configure Departments, Teams and Monitoring Forms</p>
            </div>
          </div>

          <Nav tabs className="nav-tabs-custom">
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "1",
                })}
                onClick={() => {
                  toggleCustom("1")
                }}
              >
                <span className="d-none d-sm-block">Departments</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "3",
                })}
                onClick={() => {
                  toggleCustom("3")
                }}
              >
                <span className="d-none d-sm-block">Teams</span>
              </NavLink>
            </NavItem>

            {/* <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "4",
                })}
                onClick={() => {
                  toggleCustom("4")
                }}
              >
                <span className="d-none d-sm-block">Statutory Report</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "5",
                })}
                onClick={() => {
                  toggleCustom("5")
                }}
              >
                <span className="d-none d-sm-block">
                  Health & Safety Report
                </span>
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "2",
                })}
                onClick={() => {
                  toggleCustom("2")
                }}
              >
                <span className="d-none d-sm-block">Daily Monitoring</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "4",
                })}
                onClick={() => {
                  toggleCustom("4")
                }}
              >
                <span className="d-none d-sm-block">Monthly Monitoring</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "6",
                })}
                onClick={() => {
                  toggleCustom("6")
                }}
              >
                <span className="d-none d-sm-block">Report Scoring</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "7",
                })}
                onClick={() => {
                  toggleCustom("7")
                }}
              >
                <span className="d-none d-sm-block">Validation</span>
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                style={{ cursor: "pointer" }}
                className={classnames({
                  active: customActiveTab === "8",
                })}
                onClick={() => {
                  toggleCustom("8")
                }}
              >
                <span className="d-none d-sm-block">Assign Tasks</span>
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={customActiveTab}>
            <TabPane tabId="1" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && factory.departments && (
                    <FactoryDepartments
                      update={() => getFactory()}
                      departments={factory.departments}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="2" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && customActiveTab == "2" && (
                    <FactoryForms
                      update={() => getFactory()}
                      factory={factory}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="3" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && factory.teams && (
                    <FactoryTeams
                      update={() => getFactory()}
                      teams={factory.teams}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="4" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && customActiveTab == "4" && factory.teams && (
                    <LeftNavReport
                      update={() => getFactory()}
                      factory={factory}
                      statutoryReport={factory.statutoryReport}
                      healthSafetyReport={factory.healthSafetyReport}
                      workReportScope={factory.workReportScope}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="6" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && customActiveTab == "6" && (
                    <ReportScoring
                      update={() => getFactory()}
                      factory={factory}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="7" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && customActiveTab == "7" && (
                    <ValidationConfig
                      update={() => getFactory()}
                      factory={factory}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
            <TabPane tabId="8" className="p-3">
              <Row>
                <Col sm="12">
                  {factory && customActiveTab == "8" && (
                    <AssignTasks
                      update={() => getFactory()}
                      factory={factory}
                    />
                  )}
                </Col>
              </Row>
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = (state: any) => {
  return {}
}

export default withRouter<any, any>(
  connect(mapStateToProps, { saveUserFactory: fetchFactories })(FactoryDetails)
)
